// extracted by mini-css-extract-plugin
export var addButton = "_dy-4";
export var contentBlockImage = "_dy-i";
export var contentBlockWidgetPreview = "_dy-g";
export var fulfillmentCutoffWidgetPreview = "_dy-9";
export var imageBackdrop = "_dy-6";
export var imageIcon = "_dy-8";
export var lowProfileImageContainer = "_dy-b";
export var lowProfileImageIcon = "_dy-f";
export var lowProfileImageIconContainer = "_dy-e";
export var lowProfileImagePlaceholder = "_dy-d";
export var lowProfileProductImage = "_dy-c";
export var lowProfileProductUpsellWidgetPreview = "_dy-a";
export var productCard = "_dy-5";
export var productImage = "_dy-7";
export var productReviewsWidgetPreview = "_dy-h";
export var progressBar = "_dy-1";
export var progressBarFill = "_dy-2";
export var progressBarTrack = "_dy-3";
export var shippingOptionWidgetPreview = "_dy-j";
export var shippingUpsellProgressBar = "_dy-k";
export var thresholdUpsellWidgetPreview = "_dy-0";